import InstallmentLanding from "components/landings/installment";
import { InstallmentLandingPageConfig } from "config/routeConfig/landingsRouteConfig";



const InstallmentLandingPage = () => {
    return (
        <InstallmentLanding />
    )
}

InstallmentLandingPage.config = InstallmentLandingPageConfig;

export default InstallmentLandingPage